export const DEFAULT_LABEL_SELECTOR = "antares.io/managed=true";
export const DEFAULT_MONITOR_LABEL_SELECTOR = "antares.io/monitored=true";
export const ANNOTATION_DISPLAY_NAME = "antares.io/name";
export const ANNOTATION_FS_ROOT = "antares.io/fs-root";
export const MAX_EDIT_SIZE = 10 * 1024; // 10KB
export const API_PATHS = {
    AUTH_CHECK: "/api/auth/check",
    AUTH_LOGIN: "/api/auth/login",
    AUTH_LOGOUT: "/api/auth/logout",
    ADMIN_USERS: "/api/admin/users",
    PODS: "/api/pods",
    POD: (ns, name) => `/api/pods/${ns}/${name}`,
    POD_SCALE: (ns, name) => `/api/pods/${ns}/${name}/scale`,
    POD_FS: (ns, name) => `/api/pods/${ns}/${name}/fs`,
    POD_FS_DOWNLOAD: (ns, name) => `/api/pods/${ns}/${name}/fs/download`,
    POD_FS_UPLOAD: (ns, name) => `/api/pods/${ns}/${name}/fs/upload`,
    POD_FS_MOVE: (ns, name) => `/api/pods/${ns}/${name}/fs/move`,
    POD_LOGS_HISTORY: (ns, name) => `/api/pods/${ns}/${name}/logs/history`,
    POD_METRICS: (ns, name) => `/api/pods/${ns}/${name}/metrics`,
};
export const WS_PATHS = {
    ATTACH: (ns, name) => `/api/pods/${ns}/${name}/attach`,
    LOGS: (ns, name) => `/api/pods/${ns}/${name}/logs`,
};
export const WS_MESSAGE_TYPES = {
    STDIN: "stdin",
    STDOUT: "stdout",
    STDERR: "stderr",
    RESIZE: "resize",
    ERROR: "error",
    CLOSE: "close",
};
//# sourceMappingURL=constants.js.map